import React from 'react'

interface IExternalLinkProps
  extends React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  showIcon?: boolean
  onClick?: (event: any) => void
}

/**
 * This component simply sets to open in a new tab + noreferrer noopener
 */
export function ExternalLink(props: IExternalLinkProps) {
  const { children, showIcon, className, ...otherProps } = props
  let cssClass = showIcon ? 'link--external' : ''
  if (className) {
    cssClass += ` ${props.className}`
  }
  return (
    <a {...otherProps} className={cssClass} target="_blank" rel="noreferrer noopener">
      {children}
    </a>
  )
}

export default React.memo(ExternalLink)
